import { mapKeys } from 'lodash'
import { shallowRef } from 'vue'
import { defineLocalStore } from '@/utils/localStore'
import axios from '@/plugins/axios'
import { urlOrderRelated, urlOrderTreeRelated } from '@/utils/urls'
import { handleAsync } from 'best-modules/plugins'

export const {
  useLocalStore: useRelatedOrders,
  initLocalStore: initRelatedOrders,
} = defineLocalStore('relatedOrders', (orderId: number) => {
  const relatedOrders = shallowRef<any[]>([])
  const parentOrders = shallowRef<any[]>([])
  const childrenOrders = shallowRef<any[]>([])

  const prepareOrders = (orders: any, childrenKey: any) => {
    return orders?.map((o: any) => {
      o = mapKeys(o, (value, key) => {
        if (key === childrenKey) {
          return 'children'
        } else {
          return key
        }
      })
      if (o.children.length) {
        o.children = prepareOrders(o.children, childrenKey)
      }

      return o
    })
  }

  const getTreeRelatedOrders = () => {
    return handleAsync('relatedOrders', () => {
      return axios.get(urlOrderTreeRelated(orderId)).then(res => {
        parentOrders.value = prepareOrders(
          res.data.treeParentRelatedOrders,
          'treeParentRelatedOrders'
        )

        childrenOrders.value = prepareOrders(
          res.data.treeChildrenRelatedOrders,
          'treeChildrenRelatedOrders'
        )
      })
    })
  }
  const getRelatedOrders = () => {
    return handleAsync('relatedOrders', () => {
      return axios.get(urlOrderRelated(orderId)).then(res => {
        relatedOrders.value = res.data
      })
    })
  }

  getRelatedOrders()
  getTreeRelatedOrders()

  return {
    parentOrders,
    childrenOrders,
    relatedOrders,
    getRelatedOrders,
    getTreeRelatedOrders,
  }
})
